module.exports = __webpack_public_path__ + "img/Thor Kamphefner.29480fa9.jpg";